import { setJosa } from '@/util';

export default class Validator {
	data = {};
	errors = {};
	messages = {
		required: {
			message: '$LABEL 입력해 주세요',
			josa: '을를',
		},
	};
	isValid = false;

	/**
	 * Constructor
	 * @param { Object } data
	 */
	constructor(data = {}) {
		this.data = data;
	}

	initValidator() {
		this.errors = {};
		this.isValid = false;
	}

	setError(key, rule, label) {
		if (!Array.isArray(this.errors[key])) {
			this.errors[key] = [];
		}

		const error = {};

		if (
			this.data[key].customMessages &&
			this.data[key].customMessages[rule]
		) {
			error[rule] = this.parseErrorMessage(
				this.data[key].customMessages[rule],
				label
			);
		} else {
			error[rule] = this.parseErrorMessage(this.messages[rule], label);
		}

		this.errors[key].push(error);
	}

	setCustomError(key, label, messages) {
		if (!Array.isArray(this.errors[key])) {
			this.errors[key] = [];
		}

		const error = {};

		if (typeof messages === 'string') {
			error.custom = messages.replace('$LABEL', label);
		} else if (typeof messages === 'object') {
			const josaAdded = messages.hasOwnProperty('josa')
				? setJosa(label, messages.josa)
				: label;
			error.custom = messages.message.replace('$LABEL', josaAdded);
		}

		this.errors[key].push(error);
	}

	parseErrorMessage(template, label) {
		if (
			/[가-희]/.test(label) &&
			typeof template === 'object' &&
			template.josa
		) {
			return template.message.replace(
				'$LABEL',
				setJosa(label, template.josa)
			);
		} else if (typeof template === 'object') {
			return template.message.replace('$LABEL', label);
		} else {
			return template.replace('$LABEL', label);
		}
	}

	run() {
		this.initValidator();

		Object.keys(this.data).forEach(key => {
			const data = this.data[key].data;
			const label = this.data[key].label;
			const rules = this.data[key].rules;

			rules.forEach(rule => {
				if (typeof rule === 'string') {
					switch (true) {
						case rule === 'required':
							this.validRequired(data, key, label);
							break;
						case /^(hasProperty)\:(\w+\,)+(\w+\,?)$/.test(rule):
							this.validHasProperty(rule, data, key, label);
							break;
					}
				} else if (typeof rule === 'object' && !Array.isArray(rule)) {
					if (!rule.rule(data)) {
						this.setCustomError(key, label, rule.messages);
					}
				}
			});
		});

		this.isValid = Object.keys(this.errors).length === 0;

		return this;
	}

	getFirstErrorMessage() {
		if (Object.keys(this.errors).length === 0) {
			return false;
		} else {
			const key = Object.keys(this.errors)[0];
			const error = this.errors[key][0];
			const rule = Object.keys(error)[0];

			return error[rule];
		}
	}

	validRequired(data, key, label) {
		if (typeof data !== 'number' && typeof data !== 'boolean' && !data) {
			this.setError(key, 'required', label);
		} else if (typeof data === 'string' && data.trim().length === 0) {
			this.setError(key, 'required', label);
		}
	}

	validHasProperty(rule, data, key, label) {
		const properties = rule.split(':').pop().split(',');
		let isValid = true;

		properties.forEach(property => {
			if (!data.hasOwnProperty(property)) {
				isValid = false;
			}
		});

		if (!isValid) {
			this.setError(key, 'hasProperty', label);
		}
	}

	setMessages(messages = {}) {
		Object.key(messages).forEach(key => {
			this.messages[key] = messages[key];
		});
	}
}
